// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0bf238ee","239":"62fcc53c","667":"98b94257"}[chunkId] + ".chunk.js";
};